import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../../app.config";
import { FileDocument } from "../models/file-document.model";
import { Observable } from "rxjs";
import { FileDocumentSendToAll } from '../models/file-document-send-to-all.model';
import { DEFAULT_PDF_ANALYSIS_OPTIONS, PdfAnalysisOptions } from "../models/pdf-analysis-options.model";
import { PdfAnalysisResult } from "../models/pdf-analysis-result.model";

@Injectable({ providedIn: 'root' })
export class DocumentationService {
  urlCPP = AppConfig.settings.apiUrls.cpp;

  constructor(private http: HttpClient) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(ouId: any): Observable<any> {
    return this.http.get(`${this.urlCPP}/Documentation/${ouId}`, ouId);
  }

  create(dto: FileDocument[], files?: File[], inspectionTokens?: (string | undefined)[]): Observable<FileDocument> {
    const formData = this.formDataFile(files, inspectionTokens);
    formData.append('data', JSON.stringify(dto));
    return this.http.post<FileDocument>(
      `${this.urlCPP}/FileDocuments/AltaMasivaDoc`,
      formData
    );
  }

  createDocumentsEmployees(dto: FileDocumentSendToAll, files?: File[], inspectionTokens?: (string | undefined)[]): Observable<FileDocument> {
    const formData = this.formDataFile(files, inspectionTokens);
    formData.append('data', JSON.stringify(dto));
    return this.http.post<FileDocument>(
      `${this.urlCPP}/FileDocuments/DocumentsEmployees`,
      formData
    );
  }

  employeeUpload(dto: FileDocument, files: File[]) {
    const formData = this.formDataFile(files);
    formData.append('data', JSON.stringify(dto));

    return this.http.post<FileDocument>(
      `${this.urlCPP}/EmployeeDocuments/`,
      formData
    );
  }

  createEmployeeDocument(
    dto: FileDocument,
    files: File[],
    inspectionTokens?: string | (string | undefined)[]
  ) {
    const tokens = Array.isArray(inspectionTokens)
      ? inspectionTokens
      : inspectionTokens ? files?.map(() => inspectionTokens) : undefined;
    const formData = this.formDataFile(files, tokens);
    formData.append('data', JSON.stringify(dto));

    return this.http.post<FileDocument>(
      `${this.urlCPP}/Person/AddDocument`,
      formData
    );
  }

  analizeDocument(files: File[], options?: Partial<PdfAnalysisOptions>): Observable<PdfAnalysisResult> {
    const formData = this.formDataFile(files);
    const finalOptions: PdfAnalysisOptions = {
      ...DEFAULT_PDF_ANALYSIS_OPTIONS,
      ...options
    };
    formData.append("profile", finalOptions.profile);
    formData.append("RunBVPDF", String(finalOptions.RunBVPDF));
    formData.append("RunSLPDOS", String(finalOptions.RunSLPDOS));
    formData.append("RunDCFPDF", String(finalOptions.RunDCFPDF));
    formData.append("RunMRPDF", String(finalOptions.RunMRPDF));
    return this.http.post<PdfAnalysisResult>(
      `${this.urlCPP}/FileDocuments/Sanitize`,
      formData,
    );
  }

  // Nota ECM-13897: el backend (AltaMasivaDoc) empareja cada token con su archivo por posición
  // ("pdfInspectionTokens" repetido, mismo orden que los archivos adjuntos), no por nombre. Por
  // eso es fundamental respetar el mismo orden de iteración al armar el FormData.
  private formDataFile(files: File[], inspectionTokens?: (string | undefined)[]) {
    const formData: FormData = new FormData();

    if (files && files.length > 0) {
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        formData.append(file.name, file, file.name);

        if (inspectionTokens) {
          formData.append('pdfInspectionTokens', inspectionTokens[index] ?? '');
        }
      }
    }
    return formData;
  }

}
